import { render, staticRenderFns } from "./DepartamentoGaleriaEditor.vue?vue&type=template&id=f7afa8be&scoped=true"
import script from "./DepartamentoGaleriaEditor.vue?vue&type=script&lang=js"
export * from "./DepartamentoGaleriaEditor.vue?vue&type=script&lang=js"
import style0 from "./DepartamentoGaleriaEditor.vue?vue&type=style&index=0&id=f7afa8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7afa8be",
  null
  
)

export default component.exports